import { InspectionTypeEnum } from '@authority-labs/enums';
import { BaseDto } from '../base.dto';
import { InspectionStandard } from './inspection-standard.dto';

export class InspectionType extends BaseDto {
  name?: string;
  inspectionStandardId?: number;
  inspectionStandard?: InspectionStandard;
  type?: InspectionTypeEnum;
}
